module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"label":"Introduksjon"},"en":{"label":"Introduction"}}')
  delete Component.options._Ctor
}
